"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// import * as MSAL from "@iaedge/msal-browser";
//@ts-ignore
// const MSAL = require("@iaedge/msal-browser");
var UserServices_1 = tslib_1.__importDefault(require("./UserServices"));
var jwt_decode_1 = tslib_1.__importDefault(require("jwt-decode"));
var Permissions_1 = require("../rbac/permissions/Permissions");
var AbilityService = /** @class */ (function () {
    function AbilityService() {
    }
    // public static createMsalAuthProvider(Msalconfig: MSALConfiguration, cacheLocation: "sessionStorage" | "localStorage"): any {
    //     this.setMsalConfig(Msalconfig);
    //     if (!AbilityService.AuthProvider) {
    //         const config = AbilityService.DefaultConfig(cacheLocation);
    //         config.auth = Msalconfig;
    //         AbilityService.AuthProvider = new MSAL.PublicClientApplication(
    //             config
    //         );
    //     }
    //     return AbilityService.AuthProvider;
    // }
    // public static async loginRequest(b2cName: string, solution: string, clientId: string, cacheLocation: "sessionStorage" | "localStorage") {
    //     const scopeId = `https://${b2cName}.onmicrosoft.com/${solution}/instance`;
    //     if (
    //         !window[cacheLocation][
    //         `msal.${clientId}.client.info`
    //         ]
    //     ) {
    //         try {
    //             const Params = {
    //                 scopes: AbilityService.scopes(scopeId),
    //             };
    //             await AbilityService.AuthProvider.loginRedirect(Params);
    //         } catch (e) {
    //             userServices.clearData();
    //             const errorMessage = (e && e.errorMessage && e.errorMessage) || "Login request Failed. Please try again";
    //             console.log(e);
    //             throw new Error(errorMessage);
    //         }
    //     }
    // }
    // public static getMsalAuthProvider(b2cName: string, solution: string, clientId: string, cacheLocation: "sessionStorage" | "localStorage") {
    //     let msalConfig = this.getMsalConfig();
    //     if (!AbilityService.AuthProvider) {
    //         if (msalConfig) {
    //             const tenant = this.getTenant();
    //             AbilityService.createMsalAuthProvider(msalConfig, cacheLocation);
    //             AbilityService.loginRequest(b2cName, solution, clientId, cacheLocation);
    //         } else {
    //             return null;
    //         }
    //     }
    //     return AbilityService.AuthProvider;
    // }
    // public static async fetchAccessToken(b2cName: string, solution: string) {
    //     const scopeId = `https://${b2cName}.onmicrosoft.com/${solution}/instance`;
    //     const tokenRefreshRequest = {
    //         scopes: AbilityService.scopes(scopeId),
    //         forceRefresh: true,
    //     };
    //     let hasAccessError = false;
    //     await AbilityService.AuthProvider.tokenExchangePromise.catch((error: any) => {
    //         AbilityService.isLoggedIn = false;
    //         window.stop();
    //         const errorMessage = (error && error.errorMessage && error.errorMessage) || "Login request. Please try again";
    //         console.log(errorMessage);
    //         AbilityService.callBackPointer(errorMessage);
    //         hasAccessError = true;
    //     });
    //     if (hasAccessError) {
    //         return;
    //     }
    //     const token = await AbilityService.AuthProvider.acquireTokenSilent(tokenRefreshRequest)
    //         .catch((tokenError: any) => {
    //             AbilityService.isLoggedIn = false;
    //             window.stop();
    //             const errorMessage = (tokenError && tokenError.errorMessage && tokenError.errorMessage) || "Login request. Please try again";
    //             console.log(errorMessage);
    //             AbilityService.callBackPointer(errorMessage);
    //             hasAccessError = true;
    //         });
    //     if (hasAccessError) {
    //         return;
    //     }
    //     AbilityService.decodeToken(token.accessToken);
    // }
    // public static setMsalConfig(Msalconfig: MSALConfiguration) {
    //     userServices.storeData("MsalConfig", JSON.stringify(Msalconfig));
    // }
    // public static getMsalConfig(): MSALConfiguration | null {
    //     let msalConfigJSON = userServices.getData("MsalConfig");
    //     if (msalConfigJSON) {
    //         return JSON.parse(msalConfigJSON);
    //     } else {
    //         return null;
    //     }
    // }
    AbilityService.getAccessToken = function () {
        return AbilityService.accessToken;
    };
    AbilityService.getTenant = function () {
        return UserServices_1.default.getData("tenant") ?
            UserServices_1.default.getData("tenant") : "";
    };
    AbilityService.logOut = function (clientId) {
        UserServices_1.default.clearData();
        if (AbilityService.timeout) {
            clearTimeout(AbilityService.timeout);
        }
        if (AbilityService.AuthProvider) {
            localStorage.clear();
            AbilityService.AuthProvider = null;
            location.href = "https://login.microsoftonline.com/" + clientId + "/oauth2/logout";
            // AbilityService.AuthProvider.logout();
        }
    };
    // public static setupLogin(b2cName: string, solution: string, tenant: string, clientId: string, redirectUrl: string, cacheLocation: "sessionStorage" | "localStorage") {
    //     AbilityService.AuthProvider = null;
    //     userServices.clearData();
    //     const authority = `https://${b2cName}.b2clogin.com/${b2cName}.onmicrosoft.com/b2c_1a_${solution}_${tenant}_rp`;
    //     const configObject: MSALConfiguration = {
    //         clientId,
    //         authority: authority,
    //         redirectUri: redirectUrl,
    //         tokenUrl: `${appSettings.dataProviderUrl}/api/Token`,
    //         isB2C: true
    //     };
    //     AbilityService.createMsalAuthProvider(configObject, cacheLocation);
    //     userServices.storeData("tenant", tenant);
    // }
    // public static async getRefreshAccessToken(b2cName: string, solution: string, callBackOnFailure: (errorMessage: any) => any): Promise<string | undefined> {
    //     AbilityService.callBackPointer = callBackOnFailure;
    //     const scopeId = `https://${b2cName}.onmicrosoft.com/${solution}/instance`;
    //     const tokenRefreshRequest = {
    //         scopes: AbilityService.scopes(scopeId),
    //         forceRefresh: true,
    //     };
    //     try {
    //         const token = await AbilityService.AuthProvider.acquireTokenSilent(
    //             tokenRefreshRequest
    //         );
    //         if (token) {
    //             userServices.storeData("token", token.accessToken);
    //             AbilityService.decodeToken(token.accessToken);
    //             userServices.storeData("expiredOn", token.expiresOn.getTime() + "");
    //             let currentDate = new Date();
    //             let time = token.expiresOn.getTime() - currentDate.getTime();
    //             time = time - 300000;
    //             AbilityService.timeout = setTimeout(() => {
    //                 console.log("Token refreshed at", new Date());
    //                 AbilityService.getRefreshAccessToken(b2cName, solution, callBackOnFailure);
    //             }, time);
    //             return token.accessToken;
    //         }
    //         return "";
    //     }
    //     catch (error) {
    //         callBackOnFailure(error);
    //     }
    // }
    // /**
    //  * Checks if token is expired, and updates it if ture. Will throw error in case token exchange is not successful.
    //  * @param b2cName b2cName
    //  * @param solution solution name
    //  * @param clientId client Id
    //  * @param cacheLocation "localStorage"|"sessionStorage"
    //  */
    // public static async updateAccount(b2cName: string, solution: string, clientId: string, cacheLocation: "sessionStorage" | "localStorage", callBackOnFailure: (errorMessage: any) => void): Promise<void> {
    //     AbilityService.getMsalAuthProvider(b2cName, solution, clientId, cacheLocation);
    //     AbilityService.callBackPointer = callBackOnFailure;
    //     AbilityService.clientDetails = {
    //         b2cName, solution, clientId, cacheLocation
    //     };
    //     userServices.storeData("clientDetails", JSON.stringify(AbilityService.clientDetails));
    //     if (!AbilityService.AuthProvider) {
    //         AbilityService.isLoggedIn = false;
    //         return;
    //     }
    //     const token = AbilityService.getAccessToken();
    //     if ((token === "") || AbilityService.isTokenExpired(token)) {
    //         await AbilityService.fetchAccessToken(b2cName, solution);
    //     }
    //     const newToken = AbilityService.getAccessToken();
    //     AbilityService.decodeToken(newToken);
    //     return;
    // }
    AbilityService.getClientDetails = function () {
        var value = UserServices_1.default.getData("clientDetails");
        if (value) {
            return JSON.parse(value);
        }
        return null;
    };
    AbilityService.decodeToken = function (token) {
        var decodedToken = jwt_decode_1.default(token);
        var exp = decodedToken.exp;
        if (Date.now() >= (exp * 1000)) {
            UserServices_1.default.deleteData("token");
            throw new Error("Token is invalid. Please login again");
        }
        else {
            // userServices.storeData("token", token);
            AbilityService.accessToken = token;
            Permissions_1.rbacPermissions.loadPermissions(decodedToken.permissions);
            AbilityService.user.name = decodedToken ? decodedToken.name : "";
            AbilityService.user.email = decodedToken ? decodedToken.email : "";
            AbilityService.tenantId = decodedToken.tid;
            AbilityService.isLoggedIn = true;
            AbilityService.userRoles = decodedToken.roles;
        }
    };
    AbilityService.AuthProvider = null;
    AbilityService.accessToken = "";
    AbilityService.user = { name: "", email: "" };
    AbilityService.tenantId = "";
    AbilityService.isLoggedIn = false;
    AbilityService.userRoles = [];
    return AbilityService;
}());
exports.AbilityService = AbilityService;
//# sourceMappingURL=AbilityService.js.map